<script setup>
const props = defineProps({
  count: {
    type: Number,
    default: 0,
  },
  index: {
    type: Number,
    default: 0,
  },
});
</script>

<template>
  <div v-if="props.count > 1" class="digital-display__pagination">
    <ul class="digital-display__dots">
      <li
        v-for="slide in props.count"
        :key="slide"
        class="digital-display__dot"
        :class="{ 'is-current': slide - 1 === props.index }"
      ></li>
    </ul>

    <p class="digital-display__slide-count">{{ props.index + 1 }} / {{ props.count }}</p>
  </div>
</template>
